import { render } from "./EmpleadosPerfilesForm-Component.vue?vue&type=template&id=6a5cc3fe&scoped=true"
import script from "./EmpleadosPerfilesForm-Component.vue?vue&type=script&lang=js"
export * from "./EmpleadosPerfilesForm-Component.vue?vue&type=script&lang=js"

import "./EmpleadosPerfilesForm-Component.vue?vue&type=style&index=0&id=6a5cc3fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5cc3fe"]])

export default __exports__